exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".m-loader[data-v-1fd949c8]{position:fixed;top:0;left:0;bottom:0;right:0;background-color:rgba(0,0,0,0.65);z-index:1001}.m-loader--container[data-v-1fd949c8]{position:absolute;left:50%;top:50%;-webkit-transform:translateY(-50%) translateX(-50%);-ms-transform:translateY(-50%) translateX(-50%);transform:translateY(-50%) translateX(-50%)}.m-loader .sf-loader[data-v-1fd949c8]{width:38px;height:38px;margin:0 auto}.m-loader--message[data-v-1fd949c8]{color:#fff;text-align:center;margin-top:10px}\n", ""]);

// exports
